export default __webpack_public_path__ + "static/media/Page_55.ec7b9dc4.png";